import { Port, Vessel, Route } from './../';

export class Leg {
  voyage: string;
  scheduleId: string;

  endDate: string;
  endTime: string;
  endPort: Port;
  // endLink: any;

  startDate: string;
  startTime: string;
  startPort: Port;
  // startLink: any;

  vessel: Vessel;
  route: Route;

  constructor(json: any) {
    this.voyage = json.voyage || 0;
    this.scheduleId = json.schedule_id || 0;

    this.endDate = json.end.date || '-';
    this.endTime = json.end.time || '';
    this.endPort = new Port(json.end.port);

    this.startDate = json.start.date || '-';
    this.startTime = json.start.time || '';
    this.startPort = new Port(json.start.port);

    this.vessel = new Vessel(json.vessel);
    this.route = new Route(json.route);

    // this.setStartLink();
    // this.setEndLink();
  }

  // setEndLink() {
  //   let params = {
  //     id: this.startPort.id,
  //     scroll: true
  //   };

  //   if (this.startDate.toLowerCase() !== 'blurred text') {
  //     params['date'] = this.startDate;
  //   }
  //   this.startLink = params;

  // }

  // setStartLink() {
  //   let params = {
  //     id: this.endPort.id,
  //     scroll: true
  //   };

  //   if (this.endDate.toLowerCase() !== 'blurred text') {
  //     params['date'] = this.endDate;
  //   }
  //   this.endLink = params;

  // }
}
// might want to add a try catch



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/models/trip-models/leg.ts